import { useCallback, useRef } from 'react';

export const useVibration = () => {
  const isSupported = useRef('vibrate' in navigator);

  const vibrate = useCallback((pattern = 50) => {
    if (isSupported.current) {
      try {
        navigator.vibrate(pattern);
      } catch (error) {
        console.warn('Vibration failed:', error);
      }
    }
  }, []);

  const vibrateSuccess = useCallback(() => {
    vibrate([30, 50, 30]);
  }, [vibrate]);

  const vibrateError = useCallback(() => {
    vibrate([100, 50, 100]);
  }, [vibrate]);

  const vibrateTap = useCallback(() => {
    vibrate(20);
  }, [vibrate]);

  return {
    vibrate,
    vibrateSuccess,
    vibrateError,
    vibrateTap,
    isSupported: isSupported.current
  };
};